module.exports = __webpack_public_path__ + "img/ic_24_arrow-right.f97f8c71.svg";